import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ProtectedRoute from "./Components/ProtectedRoute";
import { AuthProvider } from "./Services/AuthContext";
import AdminLayout from "./Components/Layouts/AdminLayout";
import UserLayout from "./Components/Layouts/UsersLayout";
import Dashboard from "./Pages/Admin/pages/Dashboard";
import UserList from "./Pages/Admin/pages/Users";
import './Pages/Admin/css/style.css';
import './Pages/Admin/css/table.css';
import Login from "./Pages/Login";
import MagasinLayout from "./Components/Layouts/MagasinLayout";
import MagasinLoinLayout from "./Components/Layouts/MagasinLoinLayout";
import Bordereau from "./Pages/Admin/pages/Bordereau";
import CrudManager from "./Pages/Admin/pages/CrudManager";
import { ToastContainer } from "react-toastify";
import Home from "./Pages/MagasinLoin/Home";
import Autres from "./Pages/MagasinLoin/Autres";
import HomeMagasin from "./Pages/Magasin/Home";

function App() {
  return (
    <AuthProvider>
      <Router>
        <ToastContainer
          position="top-center"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          pauseOnHover
          theme="colored"
        />
        <Routes>
          {/* Admin */}
          <Route
            path="/admin/*"
            element={
              <ProtectedRoute roles={["ROLE_ADMIN"]}>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} /> 
            <Route path="users" element={<UserList />} /> 
            <Route path="bordereau" element={<Bordereau />} /> 
            <Route path="managers" element={<CrudManager />} /> 
          </Route>
          {/* Pour magasin */}
          <Route
            path="/magasin/*"
            element={
              <ProtectedRoute roles={['ROLE_MAGASIN']}>
                <MagasinLayout/>
              </ProtectedRoute>
            }
          >
            <Route index element={<HomeMagasin />} />
          </Route>
          
          {/* Magasin loin */}
          <Route
            path="/loinmagasin/*"
            element={
              <ProtectedRoute roles={['ROLE_MAGASIN_LOIN']}>
                <MagasinLoinLayout/>
              </ProtectedRoute>
            }
          >
            <Route index element={<Home />} />
            <Route path="autres" element={<Autres />} />
          </Route>

          {/* pôur utilisateur connecter */}

          <Route
            path="/*"
            element={
              <ProtectedRoute roles={['ROLE_USER']}>
                <UserLayout/>
              </ProtectedRoute>
            }
          >
          </Route>


          <Route path="/login" element={<Login />} /> 
        </Routes>
      </Router>
    </AuthProvider>
  );
}
export default App;
